
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Products from "../pages/products/page";
import Contact from "../pages/contact/page";
import About from "../pages/about/page";
import Blog from "../pages/blog/page";
import BlogDetail from "../pages/blog/detail/page";
import ServicesPage from '../pages/services/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/products',
    element: <Products />
  },
  {
    path: '/blog',
    element: <Blog />
  },
  {
    path: '/blog/:slug',
    element: <BlogDetail />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
